import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=71dca47c&scoped=true&"
import script from "./indexPage.vue?vue&type=script&lang=js&"
export * from "./indexPage.vue?vue&type=script&lang=js&"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=71dca47c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dca47c",
  null
  
)

export default component.exports